import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Sos docente o instructor de Seguridad e Higiene y querés resolver todo el año con un solo material listo.', 'Perdés horas buscando PDFs, armando fichas, inventando evaluaciones y querés ahorrar tiempo real cada semana.', 'Te frustra que los alumnos sepan teoría pero no sepan qué hacer ante riesgos reales.', 'Querés dar clases profesionales (no escolares) pero no tenés material serio listo para usar.', 'Necesitás simulacros, checklists y actividades reales sin tener que crearlos desde cero.', 'Querés formar alumnos que actúen como futuros técnicos, no solo que memoricen.'];
export function ProblemSection() {
  return <section className="py-20 bg-gray-50" data-id="element-149">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-150">
        <div className="text-center mb-12" data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-152">
            Esto es para vos si...
          </h2>
          <div className="w-24 h-1 bg-yellow-400 mx-auto rounded-full" data-id="element-153"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-154">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-md border-l-4 border-red-500 flex items-start gap-4 hover:shadow-lg transition-shadow" data-id="element-155">
              <div className="bg-red-100 p-2 rounded-full flex-shrink-0" data-id="element-156">
                <XCircle className="w-6 h-6 text-red-600" data-id="element-157" />
              </div>
              <p className="text-gray-700 font-medium leading-relaxed" data-id="element-158">
                {point}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}